/* eslint-disable */
import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ItkEnrollmentAfficiencySAffigeeApiProxyApi } from './services/itk-enrollment-afficiency-s-affigee-api-proxy-api';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [ItkEnrollmentAfficiencySAffigeeApiProxyApi, ApiConfiguration],
})
export class GeneratedApiModule {
  static forRoot(
    params: ApiConfigurationParams,
  ): ModuleWithProviders<GeneratedApiModule> {
    return {
      ngModule: GeneratedApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: GeneratedApiModule,
    @Optional() http: HttpClient,
  ) {
    if (parentModule) {
      throw new Error(
        'GeneratedApiModule is already loaded. Import in your base AppModule only.',
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
